var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestimonialBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 342,
    viewBox: "0 0 384 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.600318 162.24C0.600318 161.334 1.33457 160.6 2.24032 160.6C3.14607 160.6 3.88032 161.334 3.88032 162.24C3.88032 163.146 3.14607 163.88 2.24032 163.88C1.33457 163.88 0.600318 163.146 0.600318 162.24Z",
    fill: "#59C3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8789 162.24C23.8789 161.334 24.6132 160.6 25.5189 160.6C26.4247 160.6 27.1589 161.334 27.1589 162.24C27.1589 163.146 26.4247 163.88 25.5189 163.88C24.6132 163.88 23.8789 163.146 23.8789 162.24Z",
    fill: "#59C3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1614 162.24C47.1614 161.334 47.8957 160.6 48.8014 160.6C49.7072 160.6 50.4414 161.334 50.4414 162.24C50.4414 163.146 49.7072 163.88 48.8014 163.88C47.8957 163.88 47.1614 163.146 47.1614 162.24Z",
    fill: "#59C3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.44 162.24C70.44 161.334 71.1743 160.6 72.08 160.6C72.9858 160.6 73.72 161.334 73.72 162.24C73.72 163.146 72.9858 163.88 72.08 163.88C71.1743 163.88 70.44 163.146 70.44 162.24Z",
    fill: "#59C3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.7186 162.24C93.7186 161.334 94.4528 160.6 95.3586 160.6C96.2643 160.6 96.9986 161.334 96.9986 162.24C96.9986 163.146 96.2643 163.88 95.3586 163.88C94.4528 163.88 93.7186 163.146 93.7186 162.24Z",
    fill: "#59C3FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.001 162.24C117.001 161.334 117.735 160.6 118.641 160.6C119.547 160.6 120.281 161.334 120.281 162.24C120.281 163.146 119.547 163.88 118.641 163.88C117.735 163.88 117.001 163.146 117.001 162.24Z",
    fill: "#59C3FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.28 162.24C140.28 161.334 141.014 160.6 141.92 160.6C142.825 160.6 143.56 161.334 143.56 162.24C143.56 163.146 142.825 163.88 141.92 163.88C141.014 163.88 140.28 163.146 140.28 162.24Z",
    fill: "#59C3FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.562 162.24C163.562 161.334 164.296 160.6 165.202 160.6C166.108 160.6 166.842 161.334 166.842 162.24C166.842 163.146 166.108 163.88 165.202 163.88C164.296 163.88 163.562 163.146 163.562 162.24Z",
    fill: "#59C3FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.841 162.24C186.841 161.334 187.575 160.6 188.481 160.6C189.387 160.6 190.121 161.334 190.121 162.24C190.121 163.146 189.387 163.88 188.481 163.88C187.575 163.88 186.841 163.146 186.841 162.24Z",
    fill: "#59C3FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.119 162.24C210.119 161.334 210.854 160.6 211.759 160.6C212.665 160.6 213.399 161.334 213.399 162.24C213.399 163.146 212.665 163.88 211.759 163.88C210.854 163.88 210.119 163.146 210.119 162.24Z",
    fill: "#59C3FF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.600318 185.52C0.600318 184.615 1.33457 183.88 2.24032 183.88C3.14607 183.88 3.88032 184.615 3.88032 185.52C3.88032 186.426 3.14607 187.16 2.24032 187.16C1.33457 187.16 0.600318 186.426 0.600318 185.52Z",
    fill: "#59C3FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8789 185.52C23.8789 184.615 24.6132 183.88 25.5189 183.88C26.4247 183.88 27.1589 184.615 27.1589 185.52C27.1589 186.426 26.4247 187.16 25.5189 187.16C24.6132 187.16 23.8789 186.426 23.8789 185.52Z",
    fill: "#59C3FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1614 185.52C47.1614 184.615 47.8957 183.88 48.8014 183.88C49.7072 183.88 50.4414 184.615 50.4414 185.52C50.4414 186.426 49.7072 187.16 48.8014 187.16C47.8957 187.16 47.1614 186.426 47.1614 185.52Z",
    fill: "#59C3FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.44 185.52C70.44 184.615 71.1743 183.88 72.08 183.88C72.9858 183.88 73.72 184.615 73.72 185.52C73.72 186.426 72.9858 187.16 72.08 187.16C71.1743 187.16 70.44 186.426 70.44 185.52Z",
    fill: "#59C3FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.7186 185.52C93.7186 184.615 94.4528 183.88 95.3586 183.88C96.2643 183.88 96.9986 184.615 96.9986 185.52C96.9986 186.426 96.2643 187.16 95.3586 187.16C94.4528 187.16 93.7186 186.426 93.7186 185.52Z",
    fill: "#59C3FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.001 185.52C117.001 184.615 117.735 183.88 118.641 183.88C119.547 183.88 120.281 184.615 120.281 185.52C120.281 186.426 119.547 187.16 118.641 187.16C117.735 187.16 117.001 186.426 117.001 185.52Z",
    fill: "#59C3FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.28 185.52C140.28 184.615 141.014 183.88 141.92 183.88C142.825 183.88 143.56 184.615 143.56 185.52C143.56 186.426 142.825 187.16 141.92 187.16C141.014 187.16 140.28 186.426 140.28 185.52Z",
    fill: "#59C3FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.562 185.52C163.562 184.615 164.296 183.88 165.202 183.88C166.108 183.88 166.842 184.615 166.842 185.52C166.842 186.426 166.108 187.16 165.202 187.16C164.296 187.16 163.562 186.426 163.562 185.52Z",
    fill: "#59C3FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.841 185.52C186.841 184.615 187.575 183.88 188.481 183.88C189.387 183.88 190.121 184.615 190.121 185.52C190.121 186.426 189.387 187.16 188.481 187.16C187.575 187.16 186.841 186.426 186.841 185.52Z",
    fill: "#59C3FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.119 185.52C210.119 184.615 210.854 183.88 211.759 183.88C212.665 183.88 213.399 184.615 213.399 185.52C213.399 186.426 212.665 187.16 211.759 187.16C210.854 187.16 210.119 186.426 210.119 185.52Z",
    fill: "#59C3FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.600318 208.8C0.600318 207.895 1.33457 207.16 2.24032 207.16C3.14607 207.16 3.88032 207.895 3.88032 208.8C3.88032 209.706 3.14607 210.44 2.24032 210.44C1.33457 210.44 0.600318 209.706 0.600318 208.8Z",
    fill: "#59C3FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8789 208.8C23.8789 207.895 24.6132 207.16 25.5189 207.16C26.4247 207.16 27.1589 207.895 27.1589 208.8C27.1589 209.706 26.4247 210.44 25.5189 210.44C24.6132 210.44 23.8789 209.706 23.8789 208.8Z",
    fill: "#59C3FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1614 208.8C47.1614 207.895 47.8957 207.16 48.8014 207.16C49.7072 207.16 50.4414 207.895 50.4414 208.8C50.4414 209.706 49.7072 210.44 48.8014 210.44C47.8957 210.44 47.1614 209.706 47.1614 208.8Z",
    fill: "#59C3FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.44 208.8C70.44 207.895 71.1743 207.16 72.08 207.16C72.9858 207.16 73.72 207.895 73.72 208.8C73.72 209.706 72.9858 210.44 72.08 210.44C71.1743 210.44 70.44 209.706 70.44 208.8Z",
    fill: "#59C3FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.7186 208.8C93.7186 207.895 94.4528 207.16 95.3586 207.16C96.2643 207.16 96.9986 207.895 96.9986 208.8C96.9986 209.706 96.2643 210.44 95.3586 210.44C94.4528 210.44 93.7186 209.706 93.7186 208.8Z",
    fill: "#59C3FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.001 208.8C117.001 207.895 117.735 207.16 118.641 207.16C119.547 207.16 120.281 207.895 120.281 208.8C120.281 209.706 119.547 210.44 118.641 210.44C117.735 210.44 117.001 209.706 117.001 208.8Z",
    fill: "#59C3FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.28 208.8C140.28 207.895 141.014 207.16 141.92 207.16C142.825 207.16 143.56 207.895 143.56 208.8C143.56 209.706 142.825 210.44 141.92 210.44C141.014 210.44 140.28 209.706 140.28 208.8Z",
    fill: "#59C3FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.562 208.8C163.562 207.895 164.296 207.16 165.202 207.16C166.108 207.16 166.842 207.895 166.842 208.8C166.842 209.706 166.108 210.44 165.202 210.44C164.296 210.44 163.562 209.706 163.562 208.8Z",
    fill: "#59C3FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.841 208.8C186.841 207.895 187.575 207.16 188.481 207.16C189.387 207.16 190.121 207.895 190.121 208.8C190.121 209.706 189.387 210.44 188.481 210.44C187.575 210.44 186.841 209.706 186.841 208.8Z",
    fill: "#59C3FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.119 208.8C210.119 207.895 210.854 207.16 211.759 207.16C212.665 207.16 213.399 207.895 213.399 208.8C213.399 209.706 212.665 210.44 211.759 210.44C210.854 210.44 210.119 209.706 210.119 208.8Z",
    fill: "#59C3FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.600318 232.08C0.600318 231.174 1.33457 230.44 2.24032 230.44C3.14607 230.44 3.88032 231.174 3.88032 232.08C3.88032 232.986 3.14607 233.72 2.24032 233.72C1.33457 233.72 0.600318 232.986 0.600318 232.08Z",
    fill: "#59C3FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8789 232.08C23.8789 231.174 24.6132 230.44 25.5189 230.44C26.4247 230.44 27.1589 231.174 27.1589 232.08C27.1589 232.986 26.4247 233.72 25.5189 233.72C24.6132 233.72 23.8789 232.986 23.8789 232.08Z",
    fill: "#59C3FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1614 232.08C47.1614 231.174 47.8957 230.44 48.8014 230.44C49.7072 230.44 50.4414 231.174 50.4414 232.08C50.4414 232.986 49.7072 233.72 48.8014 233.72C47.8957 233.72 47.1614 232.986 47.1614 232.08Z",
    fill: "#59C3FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.44 232.08C70.44 231.174 71.1743 230.44 72.08 230.44C72.9858 230.44 73.72 231.174 73.72 232.08C73.72 232.986 72.9858 233.72 72.08 233.72C71.1743 233.72 70.44 232.986 70.44 232.08Z",
    fill: "#59C3FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.7186 232.08C93.7186 231.174 94.4528 230.44 95.3586 230.44C96.2643 230.44 96.9986 231.174 96.9986 232.08C96.9986 232.986 96.2643 233.72 95.3586 233.72C94.4528 233.72 93.7186 232.986 93.7186 232.08Z",
    fill: "#59C3FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.001 232.08C117.001 231.174 117.735 230.44 118.641 230.44C119.547 230.44 120.281 231.174 120.281 232.08C120.281 232.986 119.547 233.72 118.641 233.72C117.735 233.72 117.001 232.986 117.001 232.08Z",
    fill: "#59C3FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.28 232.08C140.28 231.174 141.014 230.44 141.92 230.44C142.825 230.44 143.56 231.174 143.56 232.08C143.56 232.986 142.825 233.72 141.92 233.72C141.014 233.72 140.28 232.986 140.28 232.08Z",
    fill: "#59C3FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.562 232.08C163.562 231.174 164.296 230.44 165.202 230.44C166.108 230.44 166.842 231.174 166.842 232.08C166.842 232.986 166.108 233.72 165.202 233.72C164.296 233.72 163.562 232.986 163.562 232.08Z",
    fill: "#59C3FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.841 232.08C186.841 231.174 187.575 230.44 188.481 230.44C189.387 230.44 190.121 231.174 190.121 232.08C190.121 232.986 189.387 233.72 188.481 233.72C187.575 233.72 186.841 232.986 186.841 232.08Z",
    fill: "#59C3FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.119 232.08C210.119 231.174 210.854 230.44 211.759 230.44C212.665 230.44 213.399 231.174 213.399 232.08C213.399 232.986 212.665 233.72 211.759 233.72C210.854 233.72 210.119 232.986 210.119 232.08Z",
    fill: "#59C3FF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.600318 255.36C0.600318 254.454 1.33457 253.72 2.24032 253.72C3.14607 253.72 3.88032 254.454 3.88032 255.36C3.88032 256.266 3.14607 257 2.24032 257C1.33457 257 0.600318 256.266 0.600318 255.36Z",
    fill: "#59C3FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8789 255.36C23.8789 254.454 24.6132 253.72 25.5189 253.72C26.4247 253.72 27.1589 254.454 27.1589 255.36C27.1589 256.266 26.4247 257 25.5189 257C24.6132 257 23.8789 256.266 23.8789 255.36Z",
    fill: "#59C3FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1614 255.36C47.1614 254.454 47.8957 253.72 48.8014 253.72C49.7072 253.72 50.4414 254.454 50.4414 255.36C50.4414 256.266 49.7072 257 48.8014 257C47.8957 257 47.1614 256.266 47.1614 255.36Z",
    fill: "#59C3FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.44 255.36C70.44 254.454 71.1743 253.72 72.08 253.72C72.9858 253.72 73.72 254.454 73.72 255.36C73.72 256.266 72.9858 257 72.08 257C71.1743 257 70.44 256.266 70.44 255.36Z",
    fill: "#59C3FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.7186 255.36C93.7186 254.454 94.4528 253.72 95.3586 253.72C96.2643 253.72 96.9986 254.454 96.9986 255.36C96.9986 256.266 96.2643 257 95.3586 257C94.4528 257 93.7186 256.266 93.7186 255.36Z",
    fill: "#59C3FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.001 255.36C117.001 254.454 117.735 253.72 118.641 253.72C119.547 253.72 120.281 254.454 120.281 255.36C120.281 256.266 119.547 257 118.641 257C117.735 257 117.001 256.266 117.001 255.36Z",
    fill: "#59C3FF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.28 255.36C140.28 254.454 141.014 253.72 141.92 253.72C142.825 253.72 143.56 254.454 143.56 255.36C143.56 256.266 142.825 257 141.92 257C141.014 257 140.28 256.266 140.28 255.36Z",
    fill: "#59C3FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.562 255.36C163.562 254.454 164.296 253.72 165.202 253.72C166.108 253.72 166.842 254.454 166.842 255.36C166.842 256.266 166.108 257 165.202 257C164.296 257 163.562 256.266 163.562 255.36Z",
    fill: "#59C3FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.841 255.36C186.841 254.454 187.575 253.72 188.481 253.72C189.387 253.72 190.121 254.454 190.121 255.36C190.121 256.266 189.387 257 188.481 257C187.575 257 186.841 256.266 186.841 255.36Z",
    fill: "#59C3FF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.119 255.36C210.119 254.454 210.854 253.72 211.759 253.72C212.665 253.72 213.399 254.454 213.399 255.36C213.399 256.266 212.665 257 211.759 257C210.854 257 210.119 256.266 210.119 255.36Z",
    fill: "#59C3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3460_293)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.424 85.051C183.989 24.8102 265.708 8.85955 325.949 49.4243C386.19 89.989 402.14 171.708 361.576 231.949C321.011 292.19 239.292 308.14 179.051 267.576C118.81 227.011 102.86 145.292 143.424 85.051Z",
    fill: "url(#paint0_linear_3460_293)",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3460_293",
    x: 116.987,
    y: 22.9866,
    width: 271.027,
    height: 271.027,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3460_293"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3460_293",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3460_293",
    x1: 287.296,
    y1: 9.0092,
    x2: 245.559,
    y2: 225.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#257CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#257CFF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialBg);
export default __webpack_public_path__ + "static/media/testimonial-bg.4bd0f388d7239f7a83932d1e8b281520.svg";
export { ForwardRef as ReactComponent };